import { Alert } from '@/store/alert'
import { mockedData } from '@/store/mock/mock'
import { IApi } from '@/store/spi/api'
import {
  handleError,
  hasError,
  tryCatch,
  unknownError,
} from '@repo/shared/api/helpers'
import { AlertDTO } from '@repo/shared/dtos/alert'
import { AlertsRoutes } from '@repo/shared/routes-alerts'
import { AxiosInstance } from 'axios'

type T = {
  app: IApi['alerts']
}

export const apiAlerts: (api?: AxiosInstance) => T = (api): T => ({
  //
  // APP
  //
  app: {
    get: api
      ? async ({ organizationId, asCaseWorkerId }) => {
          const res = await tryCatch(
            async () =>
              await api.get<AlertsRoutes.get.Response>(
                AlertsRoutes.get.call({
                  asCaseWorkerId,
                  organizationId,
                }),
              ),
          )
          if (hasError(res)) return handleError(res)
          return res.alerts.map(buildAlertFromDto)
        }
      : () => {
          return Promise.resolve(mockedData.alerts)
        },

    patchOne: api
      ? async ({ alertId, beneficiaryId, fields, organizationId }) => {
          const res = await tryCatch(
            async () =>
              await api.patch<AlertsRoutes.patchOne.Response>(
                AlertsRoutes.patchOne.call({
                  organizationId,
                  beneficiaryId,
                  alertId,
                }),
                { fields } satisfies AlertsRoutes.patchOne.Request,
              ),
          )
          if (hasError(res)) return handleError(res)
          return buildAlertFromDto(res.alert)
        }
      : (p) => {
          const alert = mockedData.alerts.find((a) => a.id === p.alertId)
          if (alert)
            return Promise.resolve({
              ...alert,
              status: p.fields.status,
            })
          return Promise.resolve(unknownError)
        },
  },
})

const buildAlertFromDto = (v: AlertDTO): Alert => ({
  beneficiaryId: v.beneficiaryId,
  caseWorkerId: v.caseWorkerId,
  chatMessageId: v.chatMessageId,
  chatSessionId: v.chatSessionId,
  content: v.content,
  createdAt: v.createdAt,
  id: v.id,
  status: v.status,
  statusChangedAt: v.statusChangedAt,
  title: v.title,
})
